// Returns a function that delays invoking `func` until after `wait` ms have
// elapsed since the last call. If `immediate` is true, trigger on the leading
// edge. Adds .flush(), .cancel(), and .pending() helpers.
let debounce = (func, wait, immediate) => {
    let timeout = null;
    let lastArgs;
    let lastContext;

    function invoke() {
        func.apply(lastContext, lastArgs);
        lastArgs = lastContext = undefined;
    }

    function later() {
        timeout = null;
        if (!immediate) {
            invoke();
        }
    }

    function debounced(...args) {
        lastContext = this;
        lastArgs = args;

        const callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
            invoke();
        }
    }

    // Immediately run the pending function
    debounced.flush = function () {
        if (!timeout) return;
        clearTimeout(timeout);
        timeout = null;
        if (!immediate) {
            invoke();
        }
    };

    // Cancel any pending call
    debounced.cancel = function () {
        clearTimeout(timeout);
        timeout = null;
        lastArgs = lastContext = undefined;
    };

    // Check if there is a pending call
    debounced.pending = function () {
        return !!timeout;
    };

    return debounced;
};

export default debounce;
